module.exports = __webpack_public_path__ + "img/reply.9b445f46.svg";